import DispatchConstants from '../../constants/DispatchConstants';
import LoadingConstants from '../../constants/LoadingConstants';

const initState = () => ({
  loadingState: LoadingConstants.LOADING,
  phones: [],
  emails: [],
});

const claimMethods = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.CLAIM_UPDATE_CONTACT_METHODS:
      return {
        ...state,
        ...payload,
        loadingState: LoadingConstants.SUCCESS,
      };
    case DispatchConstants.CLAIM_SET_CONTACT_METHODS_LOADING_STATE:
      return {
        ...state,
        loadingState: payload.loadingState,
      };
    default:
      return state;
  }
};

export default claimMethods;
